import { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';

import Icon from '~/components/Icon/Icon';

import parentStyles from '../../OrderPayment.module.scss';
import { formatMinutesSeconds } from '../../utils';

import styles from './QRCodePayment.module.scss';

const QR_CODE_STEP_KEYS = [
  {
    titleKey: 'orderPaymentQrStep1Title',
    descriptionKey: 'orderPaymentQrStep1Description',
  },
  {
    titleKey: 'orderPaymentQrStep2Title',
    descriptionKey: 'orderPaymentQrStep2Description',
  },
  {
    titleKey: 'orderPaymentQrStep3Title',
    descriptionKey: 'orderPaymentQrStep3Description',
  },
  {
    titleKey: 'orderPaymentQrStep4Title',
    descriptionKey: 'orderPaymentQrStep4Description',
  },
] as const;

interface QRCodePaymentProps {
  qrCodeValue?: string;
  remainingMs: number;
  isLowTime: boolean;
}

export const QRCodePayment = ({
  qrCodeValue,
  remainingMs,
  isLowTime,
}: QRCodePaymentProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.qrCode}>
        {qrCodeValue ? (
          <QRCode
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            bgColor="var(--seed50)"
            value={qrCodeValue}
          />
        ) : (
          <Icon
            type="timer"
            size={48}
            className={`${parentStyles.timerIcon} ${styles.timerIconNoMargin}`}
          />
        )}
      </div>
      <div className={styles.qrDescription}>
        {QR_CODE_STEP_KEYS.map((step, index) => (
          <Fragment key={step.titleKey}>
            <div>
              <h4>{t(step.titleKey)}</h4>
              <p>
                {index === 0 ? (
                  <Trans
                    i18nKey={step.descriptionKey}
                    values={{ time: formatMinutesSeconds(remainingMs) }}
                    components={{ span: <span /> }}
                  />
                ) : (
                  t(step.descriptionKey)
                )}
              </p>
            </div>
            {index !== QR_CODE_STEP_KEYS.length - 1 && <hr />}
          </Fragment>
        ))}
      </div>
    </>
  );
};
